import { lazy } from "react";

const Configure = lazy(() => import("../views/PostLogin/Configure/Configure"));
const AuditReport = lazy(
  () => import("../views/PostLogin/AuditReport/AuditReport"),
);
// const CampaignAnalytics = lazy(
//   () => import("../views/PostLogin/Campaign/CampaignAnalytics"),
// );
// const AudienceAI = lazy(() => import("../views/PostLogin/Audience/AudienceAI"));
// const Support = lazy(() => import("../views/PostLogin/Support/Support"));
const ConfigureForm = lazy(
  () => import("../views/PostLogin/Configure/ConfigureForm"),
);
const ExportPDF = lazy(
  () => import("../views/PostLogin/AuditReport/ExportPDF"),
);
const GoogleExportPDF = lazy(
  () => import("../views/PostLogin/GoogleAudit/GoogleExportPDF"),
);
const GoogleAudit = lazy(
  () => import("../views/PostLogin/GoogleAudit/GoogleAuditReport"),
);
// const CreativeAI = lazy(
//   () => import("../views/PostLogin/CreativeAI/CreativeAI"),
// );
// const OptimizationAI = lazy(() =>
//   import("../views/PostLogin/OptimizationAI/OptimizationAI")
// );
const OptimizationStatus = lazy(
  () => import("../views/PostLogin/OptimizationAI/Status"),
);
const OptimizationTakeOff = lazy(
  () => import("../views/PostLogin/OptimizationAI/TakeOff"),
);
const OptimizationCoPilot = lazy(
  () => import("../views/PostLogin/OptimizationAI/CoPilot"),
);
const ConfigureOptimization = lazy(
  () => import("../views/PostLogin/Configure/ConfigureOptimization"),
);
const ConfigureBenchmark = lazy(
  () => import("../views/PostLogin/Configure/ConfigureBenchmark"),
);
const MediaPlaning = lazy(
  () => import("../views/PostLogin/MediaPlanning/MediaPlaning"),
);
const MediaPlanCreate = lazy(
  () => import("../views/PostLogin/MediaPlanning/MediaPlanCreate"),
);
const MediaExportPDF = lazy(
  () => import("../views/PostLogin/MediaPlanning/MediaExportPdf"),
);
const ConfigUser = lazy(
  () => import("../views/PostLogin/Configure/ConfigUser"),
);
// const ChangePassword = lazy(
//   () => import("../views/PostLogin/ChangePassword/ChangePassword"),
// );
const ActiveTakeOff = lazy(
  () => import("../views/PostLogin/OptimizationAI/ActiveTakeOff"),
);
const ActivityLog = lazy(
  () => import("../views/PostLogin/Configure/ActivityLog"),
);

const FeedSetting = lazy(
  () => import("../views/PostLogin/FeedManager/FeedSetting"),
);
const CatalogueList = lazy(
  () => import("../views/PostLogin/Catalogue/CatalogueList"),
);
const CatalogueEdit = lazy(
  () => import("../views/PostLogin/Catalogue/CatalogueEdit"),
);
const CatalogueView = lazy(
  () => import("../views/PostLogin/Catalogue/CatalogueView"),
);
const AddEditChannel = lazy(
  () => import("../views/PostLogin/Catalogue/AddEditChannel"),
);
const ProductStatistics = lazy(
  () => import("../views/PostLogin/ProductStatistics/ProductStatistics"),
);
const NoAccess = lazy(() => import("../views/PostLogin/NoAccess/NoAccess"));
const TakeOffHistory = lazy(
  () => import("../views/PostLogin/OptimizationAI/TakeOffHistory"),
);
const RecommendationHistory = lazy(
  () => import("../views/PostLogin/OptimizationAI/RecommendationHistory"),
);
const AdvertiserListing = lazy(
  () => import("../views/PostLogin/Configure/AdvertiserListing"),
);
export const PostLoginRoutes = [
  {
    id: 1,
    name: "Configure",
    path: "/configure",
    element: Configure,
  },
  {
    id: 2,
    name: "Audit Report",
    path: "/audit-report",
    element: AuditReport,
  },
  // {
  //   id: 3,
  //   name: "Campaign Analytics",
  //   path: "/campaign-analytics",
  //   element: CampaignAnalytics,
  // },
  // {
  //   id: 4,
  //   name: "Audience AI",
  //   path: "/audience",
  //   element: AudienceAI,
  // },
  // {
  //   id: 5,
  //   name: "Support",
  //   path: "/support",
  //   element: Support,
  // },
  {
    id: 6,
    name: "Configure Form",
    path: "/configure-form",
    element: ConfigureForm,
  },
  {
    id: 7,
    name: "Export PDF",
    path: "/export-pdf",
    element: ExportPDF,
  },
  // {
  //   id: 8,
  //   name: "Creative AI",
  //   path: "/creative-ai",
  //   element: CreativeAI,
  // },
  // {
  //   id: 9,
  //   name: "Optimization AI",
  //   path: "/optimization-ai",
  //   element: OptimizationAI,
  // },
  {
    id: 10,
    name: "Google Audit",
    path: "/google-audit",
    element: GoogleAudit,
  },
  {
    id: 11,
    name: "Google Export-PDF",
    path: "/google-export-pdf",
    element: GoogleExportPDF,
  },
  {
    id: 12,
    name: "Optimization Status",
    path: "/optimization-status",
    element: OptimizationStatus,
  },
  {
    id: 13,
    name: "Optimization Take Off",
    path: "/optimization-take-off",
    element: OptimizationTakeOff,
  },
  {
    id: 14,
    name: "Optimization CoPilot",
    path: "/optimization-co-pilot",
    element: OptimizationCoPilot,
  },
  {
    id: 15,
    name: "Configure Optimization",
    path: "/configure-optimization",
    element: ConfigureOptimization,
  },
  {
    id: 16,
    name: "Configure Benchmark",
    path: "/configure-benchmark",
    element: ConfigureBenchmark,
  },
  {
    id: 17,
    name: "Media Planning",
    path: "/media-planning",
    element: MediaPlaning,
  },
  {
    id: 18,
    name: "Media Plan Creation",
    path: "/media-planning-create",
    element: MediaPlanCreate,
  },
  {
    id: 19,
    name: "Media Export PDF",
    path: "/media-export-pdf",
    element: MediaExportPDF,
  },
  {
    id: 20,
    name: "Configure Users",
    path: "/config-users",
    element: ConfigUser,
  },
  // {
  //   id: 21,
  //   name: "Change Password",
  //   path: "/change-password",
  //   element: ChangePassword,
  // },
  {
    id: 22,
    name: "Active Take Off",
    path: "/active-take-off",
    element: ActiveTakeOff,
  },
  {
    id: 23,
    name: "Activity Log",
    path: "/activity-log",
    element: ActivityLog,
  },
  {
    id: 24,
    name: "Feed Setting",
    path: "/feed-setting",
    element: FeedSetting,
  },
  {
    id: 25,
    name: "Feed Mapping",
    path: "/feed-mapping/:channel_id",
    element: CatalogueEdit,
  },
  {
    id: 26,
    name: "Catalogue List",
    path: "/catalogue-list",
    element: CatalogueList,
  },
  {
    id: 27,
    name: "CatalogueView",
    path: "/catalogue-view/:channel_id",
    element: CatalogueView,
  },
  {
    id: 28,
    name: "ChannelDetails",
    path: "/add-channel",
    element: AddEditChannel,
  },
  {
    id: 29,
    name: "EditChannel",
    path: "/edit-channel/:channel_id",
    element: AddEditChannel,
  },
  {
    id: 30,
    name: "ProductStatistics",
    path: "/product-statistics",
    element: ProductStatistics,
  },
  { id: 31, name: "NoAccess", path: "/no-access", element: NoAccess },
  {
    id: 32,
    name: "Take Off History",
    path: "/take-off-history",
    element: TakeOffHistory,
  },
  {
    id: 33,
    name: "Recommendation History",
    path: "/copilot-recommendation-history",
    element: RecommendationHistory,
  },
  {
    id: 34,
    name: "Advertiser Listing",
    path: "/advertiser-listing",
    element: AdvertiserListing,
  },
];
